import { connect } from "react-redux";

import * as actions from "./actions";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)
import moment from "moment";

function mapStateToProps(state) {
  return { orders: state.orders };
}

function mapDispatchToProps(dispatch) {
  return {
    approveDepositOrder: (orderId, accountId, depotId, amount, date) => {
      date = moment(date).format("YYYY-MM-DD");
      dispatch(
        actions.approve_deposit_order(
          orderId,
          accountId,
          depotId,
          amount,
          date,
        ),
      );
    },

    approveWithdrawalOrder: (orderId, accountId, depotId, amount, date) => {
      date = moment(date).format("YYYY-MM-DD");
      dispatch(
        actions.approve_withdrawal_order(
          orderId,
          accountId,
          depotId,
          amount,
          date,
        ),
      );
    },

    approveWithdrawalOrders: (list) => {
      dispatch(actions.approve_withdrawal_orders(list));
    },

    cancelWithdrawalOrder: (orderId) => {
      dispatch(actions.cancel_withdrawal_order(orderId));
    },

    confirmSendBackOrder: (orderId) => {
      dispatch(actions.confirm_send_back_order(orderId));
    },

    fetchWithdrawalOrders: () => {
      dispatch(actions.get_withdraws());
    },

    fetchSendBackOrders: () => {
      dispatch(actions.get_send_backs());
    },

    fetchWithdrawalOrdersByAccount: (accountId) => {
      dispatch(actions.get_withdraws_by_account(accountId));
    },

    changeWithdrawalListPage: (page) => {
      dispatch(actions.change_withdrawal_list_page(page));
    },

    changeWithdrawalListFilter: (type, key, value) => {
      dispatch(actions.change_withdrawal_list_filter(key, value));
    },

    fetchDepositOrders: () => {
      dispatch(actions.get_deposits());
    },

    fetchDepositOrdersByAccount: (accountId) => {
      dispatch(actions.get_deposits_by_account(accountId));
    },

    changeDepositsListPage: (page) => {
      dispatch(actions.change_deposits_list_page(page));
    },

    changeDepositsListFilter: (type, key, value) => {
      dispatch(actions.change_deposits_list_filter(key, value));
    },

    swapDeposits: () => {
      dispatch(actions.swap_data());
    },
  };
}

export const ordersConnector = connect(mapStateToProps, mapDispatchToProps);
